import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionCalendar } from '../components/collectes/CollectionCalendar';
import { DayDetails } from '../components/collectes/DayDetails';
export function CalendrierCollectes() {
  const [month, setMonth] = useState(new Date(2026, 8, 1));
  const [selected, setSelected] = useState(new Date(2026, 8, 10));
  const handleSelect = (date: Date) => {
    setSelected(date);
    if (date.getMonth() !== month.getMonth()) setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
  };
  return <main className="bg-white" data-id="element-1940" data-mp="29vh96i07e0iy">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1941" data-mp="akploles99lu">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-1942" data-mp="amsjhrm6g714">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1943" data-mp="352563eqnd4t1">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1944" data-mp="30awy8n4ytrhz" />
          <Link to="/my-collections" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1945" data-mp="309lu2m7lyhqc">
            My Collections
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1946" data-mp="2rbs03hxbg06c" />
          <span aria-current="page" data-id="element-1947" data-mp="3o0r9j09mz804">Calendar</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-1948" data-mp="3nywuu3oykc4h">
          <div data-id="element-1949" data-mp="3j2fw6fk4ufd5">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1950" data-mp="3iztomfx8rzux">My Collections</h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-1951" data-mp="3a18b4z6mnb10">A calendar tailored to your address</p>
          </div>
        </header>

        <div className="mt-8" data-id="element-1952" data-mp="23lfsy99wa7gt">
          <AtnaAssistant data-id="element-1953" data-mp="23mque2fvb34r" />
        </div>

        <div className="mt-6" data-id="element-1954" data-mp="1ym2v6thhjfzg">
          <AddressCard data-id="element-1955" data-mp="1yltbtoqy472q" />
        </div>

        <Link to="/my-collections" className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-ville-deep underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1956" data-mp="1ykrtr0biikbi">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1957" data-mp="1r20pkt7nca6i" />
          Back to My Collections
        </Link>

        <div className="mt-6 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-10" data-id="element-1958" data-mp="1v68eaqe3tq4q">
          <CollectionCalendar month={month} selected={selected} onMonthChange={setMonth} onSelect={handleSelect} data-id="element-1959" data-mp="1hantfpetexuo" />
          <DayDetails date={selected} data-id="element-1960" data-mp="1m5a4frgzioe8" />
        </div>
      </div>
    </main>;
}